import React, {useCallback, useMemo, useState} from 'react';
import useApi from "../../hooks/useApi";
import IEditorOptions from "../../models/IEditorOptions";
import {SelectBox} from "devextreme-react/select-box";
import ILegendeCouleur from "../../models/ILegendeCouleur";
import {useQuery} from "@tanstack/react-query";

function useReservationCouleur() {
    const {getData: getReservationCouleur} = useApi<ILegendeCouleur[]>("reservationCouleur");
    const {data: reservationCouleur, refetch} = useQuery({
        queryKey: ['ILegendeCouleur'],
        queryFn: () => getReservationCouleur({customPath: "reservationCouleur/GetLegendeCouleurCalendrier"})
    });
    const [currentSelectedItem, setCurrentSelectedItem] = useState<ILegendeCouleur>();

    const reservationCouleurGridCellItemRender = useCallback((rowData: any) => {
        const coldata = rowData.data[rowData.column.dataField]
        const couleur = reservationCouleur?.find(f => f.idReservationCouleur.equals(coldata)) as ILegendeCouleur;
        return (
            <div title={couleur?.descriptionFrancaise || ""} style={{
                width: "90px",
                borderRadius: "4px",
                padding: "0.3em",
                overflow: "hidden",
                textOverflow: "ellipsis",
                textAlign: "center",
                height: "100%",
                color: couleur?.couleurTexte || "default",
                backgroundColor: couleur?.couleurBackground || "default"
            }}>{couleur?.descriptionFrancaise || ""}</div>
        )
    }, [reservationCouleur])

    const editorOptions = useMemo((): IEditorOptions<ILegendeCouleur[]> => {
            return {
                searchEnabled: true,
                dataSource: reservationCouleur,
                displayExpr: "descriptionFrancaise",
                displayValue: "idReservationCouleur",
                valueExpr: "idReservationCouleur",
                itemRender: reservationCouleurGridCellItemRender
            }
        }, [reservationCouleur]
    )

    const ReservationCouleurSelectBox = useCallback((params: any) => {
        const {dataField, component, column, data} = params;
        const formOptions = component.option();
        const value = dataField ? formOptions.formData[dataField] : data[column.dataField];

        const onValueChanged = (args: any) => {
            component.updateData(dataField, args.value);
        }

        const onSelectionChanged = (e: any) => {
            setCurrentSelectedItem(e.selectedItem);
        }


        return (
            <SelectBox readOnly={formOptions.readOnly} itemRender={reservationCouleurGridCellItemRender}
                       onSelectionChanged={onSelectionChanged} dataSource={editorOptions.dataSource}
                       displayExpr={editorOptions.displayExpr} displayValue={editorOptions.displayValue}
                       valueExpr={editorOptions.valueExpr} value={value} onValueChanged={onValueChanged}/>
        )
    }, [editorOptions.dataSource, editorOptions.displayExpr, editorOptions.displayValue, editorOptions.valueExpr]);

    return {
        reservationCouleurEditorOptions: editorOptions,
        reservationCouleur,
        currentReservationCouleur: currentSelectedItem,
        refreshData: () => refetch(),
        ReservationCouleurSelectBox,
        reservationCouleurBackgroundColor: currentSelectedItem?.couleurBackground,
        reservationCouleurGridCellItemRender
    }
}

export default useReservationCouleur;